import { render, staticRenderFns } from "./comment-student.vue?vue&type=template&id=e55509b8"
import script from "./comment-student.vue?vue&type=script&lang=js"
export * from "./comment-student.vue?vue&type=script&lang=js"
import style0 from "./comment-student.vue?vue&type=style&index=0&id=e55509b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports